export function scrollToCurrent(){
    const section = $(".image-section");

    const btn = section.find(".scroll-to-current");

    btn.click(function() {
        let section = $(this).parents(".image-section");

        let top = section.offset().top + section.height();

        $("body, html").animate({scrollTop: top }, 700);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to-current.js